// route access handlers expect user object as: {id: int, roles: []string}

function adminRouteAccessHandler(user) {
  let roles = user.roles || [];
  return roles.indexOf('admin') >= 0;
}

function authenticatedRouteAccessHandler(user) {
  return parseInt(user.id || 0) > 0;
}

function anonymousRouteAccessHandler(user) {
  return parseInt(user.id || 0) === 0;
}

export default {
  admin: adminRouteAccessHandler,
  authenticated: authenticatedRouteAccessHandler,
  anonymous: anonymousRouteAccessHandler
}



// WEBPACK FOOTER //
// ./src/routes/access/index.js